<template>
  <div id="weight-calculator-app">
    <div class="row">
      <div class="small-12 columns">
        <h1>Metal Weight Calculator</h1>

        <p>
          Please select Product Form, Metal Family, Alloy, and Unit of Measure
          below.<br />
          Weight will be calculated automatically.
        </p>

        <hr />

        <form id="weight-calculator-form">
          <div class="row">
            <div class="small-12 medium-4 columns">
              <product-form v-model="productForm" @input="resetDimensions" />
              <density v-model="density" />
              <tolerance-toggle v-model="tolerancesEnabled" />
            </div>

            <div class="small-12 medium-4 columns">
              <dimensions
                v-if="productForm.type && density"
                v-model="dimensions[productForm.type]"
                :product-name="productForm.name"
                :tolerances-enabled="tolerancesEnabled"
                :length-tolerance-dimension="
                  productForm.lengthToleranceDimension
                "
              />
              <p>
                <label>
                  Quantity (pcs):
                  <input v-model.number="quantity" name="quantity" />
                </label>
              </p>
            </div>

            <div class="small-12 medium-4 columns">
              <img
                v-if="productForm.image"
                :src="`/shop/images/weight_calculator/${productForm.image}.png`"
              />
            </div>
          </div>
        </form>

        <div class="row">
          <div class="small-12 columns">
            <weight
              :product-type="productForm.type"
              :density="density"
              :dimensions="dimensions[productForm.type]"
              :quantity="quantity"
            />
          </div>
        </div>

        <hr class="mt-0" />

        <div class="row">
          <div class="small-12 medium-4 columns">
            <p>
              Theoretical weight per piece based on nominal dimensions. Actual
              weight per piece can be different due to dimensional tolerances
              and variation.
            </p>
          </div>
          <div class="small-12 medium-8 columns">
            <a href="/shop/quick-quote" class="button">
              Quick Quote
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ProductForm from "components/TheProductForm.vue";
import Density from "components/TheDensity.vue";
import Dimensions from "components/TheDimensions.vue";
import Weight from "components/TheWeight.vue";
import ToleranceToggle from "components/TheToleranceToggle";

export default {
  components: {
    ProductForm,
    Density,
    Dimensions,
    Weight,
    ToleranceToggle
  },
  data() {
    return {
      productForm: {},
      density: 0,
      dimensions: {
        round: {
          diameter: {
            inches: null,
            name: "Diameter",
            value: null,
            unit: "in",
            tolerance: 0
          },
          length: {
            inches: null,
            name: "Length",
            unit: "in",
            value: null,
            tolerance: 0
          }
        },
        hex: {
          acrossFlats: {
            inches: null,
            name: "Across Flats Hex Dimension",
            value: null,
            unit: "in",
            tolerance: 0
          },
          length: {
            inches: null,
            name: "Length",
            unit: "in",
            value: null
          }
        },
        rectangle: {
          thickness: {
            inches: null,
            name: "Thickness",
            value: null,
            unit: "in",
            tolerance: 0
          },
          length: {
            inches: null,
            name: "Length",
            value: null,
            unit: "in"
          }
        },
        flat: {
          thickness: {
            inches: null,
            name: "Thickness",
            value: null,
            unit: "in",
            tolerance: 0
          },
          width: {
            inches: null,
            name: "Width",
            value: null,
            unit: "in",
            tolerance: 0
          },
          length: {
            inches: null,
            name: "Length",
            value: null,
            unit: "in"
          }
        },
        hollow: {
          outsideDiameter: {
            inches: null,
            name: "Outside Diameter",
            value: null,
            unit: "in",
            tolerance: 0
          },
          insideDiameter: {
            inches: null,
            name: "Inside Diameter",
            value: null,
            unit: "in",
            tolerance: 0
          },
          length: {
            inches: null,
            name: "Length",
            value: null,
            unit: "in"
          }
        },
        tube: {
          outsideDiameter: {
            inches: null,
            name: "Outside Diameter",
            value: null,
            unit: "in",
            tolerance: 0
          },
          wallThickness: {
            inches: null,
            name: "Wall Thickness",
            value: null,
            unit: "in",
            tolerance: 1
          },
          length: {
            inches: null,
            name: "Length",
            value: null,
            unit: "in"
          }
        }
      },
      quantity: 1,
      tolerancesEnabled: true
    };
  },
  methods: {
    resetDimensions() {
      _.forEach(this.dimensions[this.productForm.type], dimension => {
        dimension.value = null;
      });
    }
  }
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0;
}

#weight-calculator-app {
  margin-top: -50px;
}

#weight-calculator-form >>> label {
  font-size: 18px;
}

#weight-calculator-form >>> input {
  display: block;
  font-size: 14px;
  width: 50px;
}

#weight-calculator-form >>> select {
  display: block;
  font-size: 14px;
  width: 200px;
}
</style>
